import { render, staticRenderFns } from "./allenamentoFeedback.vue?vue&type=template&id=4c2538be"
import script from "./allenamentoFeedback.vue?vue&type=script&lang=js"
export * from "./allenamentoFeedback.vue?vue&type=script&lang=js"
import style0 from "./allenamentoFeedback.vue?vue&type=style&index=0&id=4c2538be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports